function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../locales/keys';
var UpdateComponentController = /*#__PURE__*/function () {
  function UpdateComponentController($timeout) {
    _classCallCheck(this, UpdateComponentController);
    this.$timeout = $timeout;
    this.localeKeys = LocaleKeys;
    this.MIN_CODE_LENGTH = 6;
    this.MAX_CODE_LENGTH = 50;
    this.MAX_NICKNAME_LENGTH = 100;
    this.formLookup = {
      nickname: LocaleKeys.DEVICE.NICKNAME,
      rendezvousCode: LocaleKeys.DEVICE.RENDEZVOUS_CODE
    };
    this.formValidationLookup = {
      minlength: {
        rendezvousCode: this.MIN_CODE_LENGTH
      },
      maxlength: {
        nickname: this.MAX_NICKNAME_LENGTH,
        rendezvousCode: this.MAX_CODE_LENGTH
      }
    };
  }
  return _createClass(UpdateComponentController, [{
    key: "handleClose",
    value: function handleClose() {
      this.resetForm();
      this.onClose()();
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit() {
      if (this.updateDevicePopupForm.$valid) {
        this.onSubmit()();
      }
    }
  }, {
    key: "isCreating",
    get: function get() {
      return this.entity && this.entity.Id === undefined;
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.updateDevicePopupForm.$setPristine();
      this.updateDevicePopupForm.$setUntouched();
    }
  }, {
    key: "onFormChange",
    value: function onFormChange() {
      this.onEntityChange()(this.entity);
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.showDeviceForm && changesObj.showDeviceForm.currentValue) {
        this.resetForm();
      }
    }
  }]);
}();
export default {
  template: require('./update.device.popup.html'),
  controller: UpdateComponentController,
  bindings: {
    entity: '<',
    formErrors: '<',
    isLoading: '<',
    showDeviceForm: '<',
    onClose: '&',
    onEntityChange: '&',
    onSubmit: '&'
  }
};